import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { ROUTE_PATHS } from 'router/routes'
// import { lazyImportComponent } from 'shared/helpers/lazyImportComponent'

const MainPage = React.lazy(() => import('pages/MainPage/MainPage'))

export class MainPageModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.MAIN} path={ROUTE_PATHS.MAIN}>
        <Switch>
          <Route key={ROUTE_PATHS.MAIN} path={ROUTE_PATHS.MAIN} component={MainPage} />
        </Switch>
      </Route>
    )
  }
}
